/*
 * Allstars 2027 — storefront behaviour (no dependencies).
 * Drawers (menu, cart, search, filters) · header state · cart (AJAX + Section Rendering API)
 * predictive search · variant picker · gallery + zoom · load more · small helpers.
 */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var html = document.documentElement;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function parse(text) { return new DOMParser().parseFromString(text, 'text/html'); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }

  /* ---------------------------------------------------------------- */
  /* Drawers                                                           */
  /* ---------------------------------------------------------------- */
  var scrim = null;
  var openDrawer = null;
  var lastFocus = null;

  function drawer(name) { return $('[data-drawer="' + name + '"]'); }

  function open(name) {
    var d = drawer(name);
    if (!d) return false;
    if (openDrawer && openDrawer !== d) close(true);
    scrim = scrim || $('[data-scrim]');
    lastFocus = document.activeElement;
    d.hidden = false;
    if (scrim) scrim.hidden = false;
    // next frame so the transition runs
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        d.classList.add('is-open');
        if (scrim) scrim.classList.add('is-open');
      });
    });
    document.body.classList.add('is-locked');
    document.body.setAttribute('data-open-drawer', name);
    openDrawer = d;
    $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusTarget = $('[data-predictive-input]', d) || $('[data-drawer-close]', d);
    if (focusTarget) setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 60);
    return true;
  }

  function close(instant) {
    var d = openDrawer;
    if (!d) return;
    openDrawer = null;
    d.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    document.body.removeAttribute('data-open-drawer');
    $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var done = function () { if (!d.classList.contains('is-open')) d.hidden = true; if (scrim && !openDrawer) scrim.hidden = true; };
    if (instant) done(); else setTimeout(done, 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var opener = t.closest('[data-drawer-open]');
    if (opener && open(opener.getAttribute('data-drawer-open'))) { e.preventDefault(); return; }
    if (t.closest('[data-menu-open]')) { e.preventDefault(); open('menu'); return; }
    if (t.closest('[data-search-open]')) { if (open('search')) e.preventDefault(); return; }
    if (t.closest('[data-cart-open]') && theme.cartType === 'drawer' && !document.body.classList.contains('template-cart')) {
      if (open('cart')) e.preventDefault();
      return;
    }
    if (t.closest('[data-drawer-close]') || t.closest('[data-scrim]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawer) close();
    // simple focus trap
    if (e.key === 'Tab' && openDrawer) {
      var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, summary', openDrawer)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------------------------------------------------------- */
  /* Header: overlay → solid on scroll, sticky offsets, announcements   */
  /* ---------------------------------------------------------------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var overlay = header.hasAttribute('data-overlay');
    function onScroll() {
      if (overlay) header.classList.toggle('is-solid', window.scrollY > 24);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    function setVars() {
      html.style.setProperty('--sticky-top', header.getBoundingClientRect().height + 'px');
    }
    setVars();
    window.addEventListener('resize', debounce(setVars, 150));

    var bar = $('[data-announce]');
    if (bar) {
      var msgs = $$('.announce__msg', bar);
      if (msgs.length > 1) {
        var i = 0;
        setInterval(function () {
          if (document.hidden) return;
          var cur = msgs[i];
          i = (i + 1) % msgs.length;
          cur.classList.remove('is-active');
          cur.classList.add('is-leaving');
          setTimeout(function () { cur.classList.remove('is-leaving'); }, 520);
          msgs[i].classList.add('is-active');
        }, 4000);
      }
    }
  }

  /* ---------------------------------------------------------------- */
  /* Cart                                                              */
  /* ---------------------------------------------------------------- */
  function updateCount(count) {
    if (count === undefined || count === null || count === '') return;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = '(' + count + ')'; });
  }

  function renderCartDrawer(sectionsHtml) {
    var markup = sectionsHtml && sectionsHtml['cart-drawer'];
    if (!markup) return;
    var doc = parse(markup);
    var fresh = $('[data-cart-content]', doc);
    var cur = $('[data-cart-content]');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    var cnt = $('[data-cart-count-inner]', doc);
    var curCnt = $('[data-cart-count-inner]');
    if (cnt && curCnt) curCnt.textContent = cnt.textContent;
  }

  function cartPageRefresh() {
    var page = $('[data-cart-page]');
    if (!page) return Promise.resolve();
    var sectionEl = page.closest('.shopify-section');
    if (!sectionEl) { location.reload(); return Promise.resolve(); }
    var id = sectionEl.id.replace('shopify-section-', '');
    return fetch(routes.cart + '?section_id=' + encodeURIComponent(id))
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var fresh = $('[data-cart-page]', parse(t));
        if (fresh) page.innerHTML = fresh.innerHTML;
      });
  }

  function changeLine(line, qty, scope) {
    if (scope) scope.classList.add('is-updating');
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status && cart.status >= 400) throw new Error(cart.description || cart.message);
        updateCount(cart.item_count);
        renderCartDrawer(cart.sections);
        return cartPageRefresh();
      })
      .catch(function (err) { console.error(err); })
      .then(function () { if (scope) scope.classList.remove('is-updating'); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-qty-change]');
    if (!b) return;
    e.preventDefault();
    var line = b.closest('[data-line]');
    if (!line) return;
    changeLine(Number(line.getAttribute('data-line')), Number(b.getAttribute('data-qty-change')), line.closest('.cart-drawer, [data-cart-page]'));
  });

  function addToCart(form, button) {
    var err = $('[data-add-error]', form);
    if (err) err.hidden = true;
    button.classList.add('is-loading');
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    return fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status >= 400) {
          if (err) { err.textContent = res.description || res.message || 'Could not add this item.'; err.hidden = false; }
          return;
        }
        renderCartDrawer(res.sections);
        var cnt = $('[data-cart-count-inner]');
        if (cnt) updateCount(cnt.textContent.trim());
        open('cart');
      })
      .catch(function () { form.submit(); })
      .then(function () { button.classList.remove('is-loading'); });
  }

  // Returns the first option group with nothing picked yet (sizes start unselected).
  function missingChoice(form) {
    return $$('fieldset[data-option-index]', form).filter(function (fs) { return !$('input:checked', fs); })[0] || null;
  }
  function askForChoice(form, fs) {
    var err = $('[data-add-error]', form);
    var name = ($('legend', fs) || {}).firstChild;
    name = name && name.textContent ? name.textContent.trim().toLowerCase() : 'size';
    if (err) { err.textContent = 'Choose a ' + name + ' first.'; err.hidden = false; }
    fs.classList.remove('is-missing');
    void fs.offsetWidth;
    fs.classList.add('is-missing');
    fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var first = $('input[data-option-input]', fs);
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-product-form]')) return;
    var gap = missingChoice(form);
    if (gap) { e.preventDefault(); askForChoice(form, gap); return; }
    if (theme.cartType !== 'drawer') return;
    var button = $('[data-add-button]', form);
    if (!button || button.disabled) { e.preventDefault(); return; }
    e.preventDefault();
    addToCart(form, button);
  });

  /* ---------------------------------------------------------------- */
  /* Predictive search                                                 */
  /* ---------------------------------------------------------------- */
  function initSearch() {
    var input = $('[data-predictive-input]');
    var out = $('[data-predictive-results]');
    if (!input || !out) return;
    var ctrl = null;
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var url = routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search&resources[type]=product,collection,page,query&resources[limit]=4&resources[options][fields]=title,product_type,variants.title,tag';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var inner = $('[data-predictive-inner]', parse(t));
          out.innerHTML = inner ? inner.outerHTML : '';
        })
        .catch(function () {});
    }, 220);
    input.addEventListener('input', run);
  }

  /* ---------------------------------------------------------------- */
  /* Product: variants, gallery, zoom                                  */
  /* ---------------------------------------------------------------- */
  // Mobile add-to-bag bar: shows while the real Add to bag button is off screen.
  function initBuyBar(root, form, addBtn, addLabel) {
    var bar = $('[data-pdp-bar]');
    var actions = $('.pdp__actions', form);
    if (!bar || !actions || !('IntersectionObserver' in window)) return;
    var btn = $('[data-pdp-bar-btn]', bar);
    var title = $('.pdp__title', root);
    var barTitle = $('[data-pdp-bar-title]', bar);
    if (title && barTitle) barTitle.textContent = title.textContent.trim();
    var mq = window.matchMedia('(max-width: 749px)');
    var offScreen = false;
    function sync() {
      btn.textContent = addLabel.textContent.trim();
      btn.disabled = addBtn.disabled;
      var show = mq.matches && offScreen && !addBtn.disabled;
      bar.hidden = !show;
      document.body.classList.toggle('has-pdp-bar', show);
    }
    new IntersectionObserver(function (entries) {
      offScreen = !entries[0].isIntersecting;
      sync();
    }, { rootMargin: '0px 0px -40px 0px' }).observe(actions);
    new MutationObserver(sync).observe(addBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    if (mq.addEventListener) mq.addEventListener('change', sync);
    btn.addEventListener('click', function () {
      var gap = missingChoice(form);
      if (gap) { askForChoice(form, gap); return; }
      if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
    });
    sync();
  }

  function initProduct(root) {
    var jsonEl = $('[data-product-json]');
    var form = $('[data-product-form]', root);
    if (!jsonEl || !form) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var select = $('select[name="id"]', form);
    var fieldsets = $$('fieldset[data-option-index]', form);
    var addBtn = $('[data-add-button]', form);
    var addLabel = $('[data-add-label]', form);
    var priceEl = $('.pdp__price', root);

    function selected() {
      return fieldsets.map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }
    function find(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(opts) {
      fieldsets.forEach(function (fs, idx) {
        $$('input[data-option-input]', fs).forEach(function (input) {
          var test = opts.slice();
          test[idx] = input.value;
          var match = data.variants.some(function (v) {
            for (var j = 0; j < test.length; j++) {
              if ((j === idx || j < idx) && test[j] != null) { if (v.options[j] !== test[j]) return false; }
            }
            return v.available;
          });
          input.closest('.opt__btn').classList.toggle('is-soldout', !match);
        });
      });
    }
    function update() {
      var opts = selected();
      var v = find(opts);
      fieldsets.forEach(function (fs, idx) {
        var chosen = $('[data-option-chosen]', fs);
        if (chosen) chosen.textContent = ' ' + (opts[idx] || '');
      });
      markAvailability(opts);
      var err = $('[data-add-error]', form);
      if (err) err.hidden = true;
      fieldsets.forEach(function (fs) { if ($('input:checked', fs)) fs.classList.remove('is-missing'); });
      if (opts.indexOf(null) > -1) {
        addBtn.disabled = false;
        addLabel.textContent = 'Select a size';
        return;
      }
      if (!v) {
        addBtn.disabled = true;
        addLabel.textContent = (theme.strings && theme.strings.unavailable) || 'Unavailable';
        return;
      }
      if (select) select.value = String(v.id);
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? ((theme.strings && theme.strings.addToBag) || 'Add to bag') : ((theme.strings && theme.strings.soldOut) || 'Sold out');
      if (priceEl) {
        var now = $('.price__now', priceEl);
        if (now) now.textContent = v.price;
        var was = $('.price__was', priceEl);
        if (v.compare_at_price) {
          priceEl.classList.add('price--sale');
          if (!was) { was = document.createElement('s'); was.className = 'price__was'; priceEl.appendChild(was); }
          was.textContent = v.compare_at_price;
        } else {
          priceEl.classList.remove('price--sale');
          if (was) was.remove();
        }
      }
      var barPrice = $('[data-pdp-bar-price]');
      if (barPrice) barPrice.textContent = v.price;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.featured_media) {
        var slide = $('[data-media-id="' + v.featured_media + '"]', root);
        var gallery = $('[data-gallery]', root);
        if (slide && gallery) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) update();
    });
    markAvailability(selected());
    initBuyBar(root, form, addBtn, addLabel);

    // Gallery: one photo at a time, arrows, counter, thumbnails
    var gallery = $('[data-gallery]', root);
    var idx = $('[data-gallery-index]', root);
    var prev = $('[data-gallery-prev]', root);
    var next = $('[data-gallery-next]', root);
    var thumbs = $$('[data-thumb]', root);
    if (gallery) {
      var total = $$('.pdp__slide', gallery).length;
      var current = function () { return Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth)); };
      var go = function (n) {
        n = Math.max(0, Math.min(total - 1, n));
        gallery.scrollTo({ left: n * gallery.clientWidth, behavior: 'smooth' });
      };
      var sync = function () {
        var n = current();
        if (idx) idx.textContent = n + 1;
        if (prev) prev.disabled = n <= 0;
        if (next) next.disabled = n >= total - 1;
        thumbs.forEach(function (t, i) {
          if (i === n) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
      };
      gallery.addEventListener('scroll', debounce(sync, 60), { passive: true });
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-thumb'), 10)); });
      });
      gallery.setAttribute('tabindex', '0');
      gallery.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
      });
      sync();
    }

    // Zoom
    var dlg = $('[data-zoom-dialog]');
    if (dlg && typeof dlg.showModal === 'function') {
      root.addEventListener('click', function (e) {
        var z = e.target.closest('[data-zoom]');
        if (!z) return;
        $$('img[data-src]', dlg).forEach(function (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); });
        dlg.showModal();
        var target = $('[data-zoom-img="' + z.getAttribute('data-zoom') + '"]', dlg);
        if (target) setTimeout(function () { target.scrollIntoView({ block: 'start' }); }, 30);
      });
      dlg.addEventListener('click', function (e) {
        if (e.target.closest('[data-zoom-close]') || e.target.tagName === 'IMG') dlg.close();
      });
    }
  }

  /* ---------------------------------------------------------------- */
  /* Load more (collection + search)                                   */
  /* ---------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-load-more-link]');
    if (!a) return;
    e.preventDefault();
    var grid = $(a.getAttribute('data-grid-target'));
    if (!grid) { window.location.href = a.href; return; }
    a.classList.add('is-loading');
    fetch(a.href)
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var doc = parse(t);
        var freshGrid = $(a.getAttribute('data-grid-target'), doc);
        if (freshGrid) $$('.grid__item', freshGrid).forEach(function (li) { grid.appendChild(li); });
        var freshLink = $('[data-load-more-link]', doc);
        var count = $('[data-load-more-count]');
        var freshCount = $('[data-load-more-count]', doc);
        if (count && freshCount) count.textContent = freshCount.textContent;
        if (freshLink) a.href = freshLink.href; else a.remove();
        a.classList.remove('is-loading');
      })
      .catch(function () { window.location.href = a.href; });
  });

  /* ---------------------------------------------------------------- */
  /* Small helpers                                                     */
  /* ---------------------------------------------------------------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-collapsible-toggle]');
    if (!b) return;
    var w = b.closest('[data-collapsible]');
    var collapsed = w.getAttribute('data-collapsed') === 'true';
    w.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
    b.setAttribute('aria-expanded', String(collapsed));
    b.textContent = collapsed ? 'Read less' : 'Read more';
  });

  function initCollapsibles() {
    $$('[data-collapsible]').forEach(function (w) {
      var text = w.firstElementChild;
      var btn = $('[data-collapsible-toggle]', w);
      if (text && btn && text.scrollHeight <= text.clientHeight + 2) btn.hidden = true;
    });
  }

  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.children.length) return;
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var fresh = $('[data-recommendations]', parse(t));
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  function boot() {
    initHeader();
    initSearch();
    $$('[data-product]').forEach(initProduct);
    initCollapsibles();
    initRecommendations();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.AllstarsTheme = { openDrawer: open, closeDrawer: close };
})();

/* Fit the footer wordmark exactly to the page width */
(function () {
  function fit() {
    var el = document.querySelector('.site-footer__wordmark span');
    if (!el) return;
    var box = el.parentElement;
    var avail = box.clientWidth - parseFloat(getComputedStyle(box).paddingLeft) * 2;
    el.style.fontSize = '100px';
    var w = el.scrollWidth;
    if (w > 0) el.style.fontSize = Math.floor((100 * avail) / w * 10) / 10 + 'px';
  }
  function run() {
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit); else fit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 150); });
})();
